"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAdminSetNewFeesInstruction = exports.createAdminCommitNewAdminInstruction = exports.createAdminApplyNewAdminInstruction = exports.createAdminSetFeeAccountInstruction = exports.createAdminUnpauseInstruction = exports.createAdminPauseInstruction = exports.createAdminStopRampAInstruction = exports.createAdminRampAInstruction = exports.AdminInstruction = void 0;
const token_utils_1 = require("@saberhq/token-utils");
const BufferLayout = __importStar(require("@solana/buffer-layout"));
const web3_js_1 = require("@solana/web3.js");
const fees_1 = require("../state/fees");
const layout_1 = require("../state/layout");
const common_1 = require("./common");
/**
 * Admin instruction.
 */
var AdminInstruction;
(function (AdminInstruction) {
    AdminInstruction[AdminInstruction["RAMP_A"] = 100] = "RAMP_A";
    AdminInstruction[AdminInstruction["STOP_RAMP_A"] = 101] = "STOP_RAMP_A";
    AdminInstruction[AdminInstruction["PAUSE"] = 102] = "PAUSE";
    AdminInstruction[AdminInstruction["UNPAUSE"] = 103] = "UNPAUSE";
    AdminInstruction[AdminInstruction["SET_FEE_ACCOUNT"] = 104] = "SET_FEE_ACCOUNT";
    AdminInstruction[AdminInstruction["APPLY_NEW_ADMIN"] = 105] = "APPLY_NEW_ADMIN";
    AdminInstruction[AdminInstruction["COMMIT_NEW_ADMIN"] = 106] = "COMMIT_NEW_ADMIN";
    AdminInstruction[AdminInstruction["SET_NEW_FEES"] = 107] = "SET_NEW_FEES";
})(AdminInstruction = exports.AdminInstruction || (exports.AdminInstruction = {}));
/**
 * Creates a ramp A instruction.
 */
const createAdminRampAInstruction = ({ config, state: { adminAccount }, targetAmp, stopRamp, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: true },
        { pubkey: adminAccount, isSigner: true, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([
        BufferLayout.u8("instruction"),
        (0, token_utils_1.Uint64Layout)("targetAmp"),
        BufferLayout.ns64("stopRampTS"),
    ]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: AdminInstruction.RAMP_A,
            targetAmp,
            stopRampTS: Math.floor(stopRamp.getTime() / 1000),
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.createAdminRampAInstruction = createAdminRampAInstruction;
/**
 * Creates a stop ramp A instruction.
 */
const createAdminStopRampAInstruction = ({ config, state: { adminAccount }, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: true },
        { pubkey: adminAccount, isSigner: true, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([BufferLayout.u8("instruction")]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: AdminInstruction.STOP_RAMP_A,
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.createAdminStopRampAInstruction = createAdminStopRampAInstruction;
/**
 * Creates a pause instruction.
 */
const createAdminPauseInstruction = ({ config, state: { adminAccount }, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: true },
        { pubkey: adminAccount, isSigner: true, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([BufferLayout.u8("instruction")]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: AdminInstruction.PAUSE,
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.createAdminPauseInstruction = createAdminPauseInstruction;
/**
 * Creates an unpause instruction.
 */
const createAdminUnpauseInstruction = ({ config, state: { adminAccount }, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: true },
        { pubkey: adminAccount, isSigner: true, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([BufferLayout.u8("instruction")]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: AdminInstruction.UNPAUSE,
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.createAdminUnpauseInstruction = createAdminUnpauseInstruction;
/**
 * Creates a set fee account instruction.
 */
const createAdminSetFeeAccountInstruction = ({ config, state: { adminAccount }, tokenAccount, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: true },
        { pubkey: adminAccount, isSigner: true, isWritable: false },
        { pubkey: tokenAccount, isSigner: false, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([BufferLayout.u8("instruction")]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: AdminInstruction.SET_FEE_ACCOUNT,
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.createAdminSetFeeAccountInstruction = createAdminSetFeeAccountInstruction;
/**
 * Creates a set new fees instruction.
 */
const createAdminApplyNewAdminInstruction = ({ config, state: { adminAccount }, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: true },
        { pubkey: adminAccount, isSigner: true, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([BufferLayout.u8("instruction")]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: AdminInstruction.APPLY_NEW_ADMIN,
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.createAdminApplyNewAdminInstruction = createAdminApplyNewAdminInstruction;
/**
 * Creates a set new fees instruction.
 */
const createAdminCommitNewAdminInstruction = ({ config, state: { adminAccount }, newAdminAccount, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: true },
        { pubkey: adminAccount, isSigner: true, isWritable: false },
        { pubkey: newAdminAccount, isSigner: true, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([BufferLayout.u8("instruction")]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: AdminInstruction.COMMIT_NEW_ADMIN,
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.createAdminCommitNewAdminInstruction = createAdminCommitNewAdminInstruction;
/**
 * Creates a set new fees instruction.
 */
const createAdminSetNewFeesInstruction = ({ config, state: { adminAccount }, fees = fees_1.ZERO_FEES, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: true },
        { pubkey: adminAccount, isSigner: true, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([BufferLayout.u8("instruction"), layout_1.FeesLayout]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: AdminInstruction.SET_NEW_FEES,
            fees: (0, fees_1.encodeFees)(fees),
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.createAdminSetNewFeesInstruction = createAdminSetNewFeesInstruction;
//# sourceMappingURL=admin.js.map